import { useEffect } from 'react'
import { useExperiment } from './useExperiment'
import { BFF_USER_RATING } from 'src/constants/experiments'

export function useUserRatingReviews(shouldTrack: boolean = true) {
  const { active, enabled, trackExperimentViewed } = useExperiment(
    BFF_USER_RATING
  )

  useEffect(() => {
    if (shouldTrack && (enabled || active)) {
      const storageKey = `${BFF_USER_RATING.name}_tracked`

      if (!window.sessionStorage.getItem(storageKey)) {
        trackExperimentViewed()
        window.sessionStorage.setItem(storageKey, 'true')
      }
    }
  }, [shouldTrack, enabled, active, trackExperimentViewed])

  return {
    showUserReviews: active
  }
}
